import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Link from "nekrasovka-ui/Link";
import Accordion from "nekrasovka-ui/Accordion";
import Mention from "containers/Mention";
import Editing from "containers/Editing";
import Section from "components/Section";
import styled from "styled-components";
import Icon from "nekrasovka-ui/Icons";

import { fetchPerson, clearPerson } from "modules/person/actions";
import { editingToggle } from "modules/editing/actions";

const StyledSection = styled(Section)`
  @media (max-width: 820px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 568px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const BackHomeLink = styled(Link)`
  display: block;
  font-family: Rubik, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  margin: 20px 0;

  color: #000000;

  svg {
    margin-right: 10px;
  }

  @media (max-width: 568px) {
    font-size: 12px;
  }

  @media (max-width: 800px) {
    padding: 0 20px;
  }
`;

const PersonPage = ({
  fetchPerson,
  clearPerson,
  editingToggle,
  isLoaded,
  person,
  editing,
  match: {
    params: { id },
  },
}) => {
  const [isEditPerson, setEditPerson] = useState(false);
  useEffect(() => {
    fetchPerson(id);

    return () => clearPerson();
  }, [id]);

  useEffect(() => {
    setEditPerson(false);
  }, [!editing]);

  const handleEditPerson = () => editingToggle(person, "person");
  const handleSetEditPerson = () => setEditPerson(!isEditPerson);

  return (
    <StyledSection>
      <BackHomeLink to="/">
        <Icon icon="arrowLeft" width="16" height="8" />
        Перейти на главную страницу
      </BackHomeLink>
      {editing ? (
        <Editing />
      ) : (
        isLoaded && (
          <Accordion
            title={person.name}
            description={person.description}
            person={false}
            open={!editing}
            disabled={!!person.mentions.length}
            onEditClick={handleSetEditPerson}
            onTitleClick={isEditPerson ? handleEditPerson : null}
            onDescriptionClick={isEditPerson ? handleEditPerson : null}
            isContentDisabled={false}
          >
            {person.mentions.map((mention, index) => (
              <Mention key={index} edit={isEditPerson} mention={mention} />
            ))}
          </Accordion>
        )
      )}
    </StyledSection>
  );
};

const mapStateToProps = ({
  editing: { editing },
  person: { person, isLoaded },
}) => ({
  editing,
  person,
  isLoaded,
});

export default connect(mapStateToProps, {
  fetchPerson,
  editingToggle,
  clearPerson,
})(PersonPage);



// WEBPACK FOOTER //
// ./src/containers/PersonPage/index.js